export default __webpack_public_path__ + "static/media/react-icon.93078681.png";